import React from 'react';
import {Container, Row, Col} from 'react-bootstrap';
import BaseModal from './BaseModal';
import {FormModalProps} from './types';

const FormModal: React.FC<FormModalProps> = ({
    isOpen,
    onClose,
    title,
    size = 'lg',
    centered = true,
    backdrop = 'static',
    className = '',
    children,
    footer,
    hideCloseButton = false,
    maxWidth = '12',
}) => {
    const colSize = maxWidth === '12' ? 12 : parseInt(maxWidth, 10) || 12;

    return (
        <BaseModal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            size={size}
            centered={centered}
            backdrop={backdrop}
            className={className}
            footer={footer}
            hideCloseButton={hideCloseButton}
        >
            <Container>
                <Row>
                    <Col md={colSize} className="m-auto">
                        {children}
                    </Col>
                </Row>
            </Container>
        </BaseModal>
    );
};

export default FormModal;
